module.exports = __webpack_public_path__ + "static/img/043 1.fc1c5737.jpg";